import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './index.less'

const VideoeHorizontalSwipper = ({ sectionId, videoListLength }) => {
  const IS_MOBILE = window.XBLOOM3.IS_MOBILE
  const DomRef = useRef(null)
  const SwiperDom = useRef(null)

  const playVideo = e => {
    e?.target?.play?.()
  }

  const stopVideo = e => {
    if (e?.target) {
      e?.target?.pause?.()
      e.target.currentTime = 0
    }
  }

  useEffect(() => {
    DomRef.current = document.querySelector(`[section-id=${sectionId}]`)
    SwiperDom.current = DomRef.current.querySelector('.swiper')
    initSlide()
  }, [])

  const initSlide = () => {
    if (!window?.XBLOOM3?.Swiper) return

    // swipper slider number of pc, default value is 3
    // eg: <video-horizontal-swipper data-pc-num="4" ...>...</video-horizontal-swipper>
    let pcNum = parseInt(DomRef.current?.dataset?.pcNum ?? '3')
    let spacing = parseInt(DomRef.current?.dataset?.pcSpace ?? '32') // space between slide
    if (window.XBLOOM3.IS_MOBILE && DomRef.current?.dataset?.mobileSpace) spacing = parseInt(DomRef.current?.dataset?.mobileSpace)

    if (!SwiperDom.current) return

    const videoLen = videoListLength * 1 > pcNum ? pcNum : videoListLength
    if (SwiperDom.current.swiper) {
      SwiperDom.current.swiper.params.slideToClickedSlide = IS_MOBILE
      SwiperDom.current.swiper.params.centeredSlides = IS_MOBILE
      SwiperDom.current.swiper.params.slidesPerView = IS_MOBILE ? 1 : videoLen
      SwiperDom.current.swiper.params.spaceBetween = spacing
      SwiperDom.current.swiper.params.loop = IS_MOBILE
      SwiperDom.current.swiper.update?.()
      SwiperDom.current.swiper.slideTo(0)
      return
    }

    new window.XBLOOM3.Swiper(SwiperDom.current, {
      grabCursor: true,
      slideToClickedSlide: IS_MOBILE,
      centeredSlides: IS_MOBILE,
      slidesPerView: IS_MOBILE ? 1 : videoLen,
      spaceBetween: spacing,
      loop: IS_MOBILE,
      mousewheel: {
        forceToAxis: true,
        thresholdTime: 300
      }
    })

    const videoDomList = SwiperDom.current.querySelectorAll('video')
    if (!videoDomList?.length) return

    if (!IS_MOBILE) {
      videoDomList.forEach(video => {
        video.addEventListener('mouseover', playVideo)
        video.addEventListener('mouseout', stopVideo)
      })

      return () => {
        const videoDomList = SwiperDom.current.querySelectorAll('video')
        if (!videoDomList?.length) return
        videoDomList.forEach(video => {
          video.removeEventListener('mouseover', playVideo)
          video.removeEventListener('mouseout', stopVideo)
        })
      }
    }

    videoDomList.forEach(video => {
      video?.play?.()
    })
  }

  return (<div></div>)
}

window.XBLOOM3.DefineXbloomSectionReactComponent('video-horizontal-swipper', VideoeHorizontalSwipper, ReactDOM)